// src/features/stock/components/StockStatistics.js
import React from 'react';
import { 
  Package, 
  AlertTriangle, 
  Clock, 
  DollarSign,
  TrendingUp,
  TrendingDown
} from 'lucide-react';

const StockStatistics = ({ stats }) => {
  const statCards = [
    {
      title: 'Total Items',
      value: stats?.totalItems || 0,
      icon: Package,
      color: 'bg-blue-500',
      change: stats?.itemChange || '+12%',
      trend: 'up',
    },
    {
      title: 'Total Value',
      value: `$${stats?.totalValue?.toLocaleString() || 0}`,
      icon: DollarSign,
      color: 'bg-green-500',
      change: stats?.valueChange || '+8%',
      trend: 'up',
    },
    {
      title: 'Low Stock Items',
      value: stats?.lowStockItems || 0,
      icon: AlertTriangle,
      color: 'bg-yellow-500',
      change: stats?.lowStockChange || '-5%',
      trend: 'down',
    },
    {
      title: 'Expiring Soon',
      value: stats?.expiringSoon || 0,
      icon: Clock,
      color: 'bg-red-500',
      change: stats?.expiringChange || '+3%',
      trend: 'up',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      {statCards.map((stat, index) => {
        const Icon = stat.icon;
        const TrendIcon = stat.trend === 'up' ? TrendingUp : TrendingDown;
        const trendColor = stat.trend === 'up' ? 'text-green-600' : 'text-red-600';

        return (
          <div key={index} className="bg-white rounded-xl shadow-sm p-6">
            <div className="flex items-center justify-between mb-4">
              <div className={`${stat.color} p-3 rounded-lg`}>
                <Icon className="h-6 w-6 text-white" />
              </div>
              <span className={`text-sm font-medium ${trendColor} flex items-center`}>
                <TrendIcon className="h-4 w-4 mr-1" />
                {stat.change}
              </span>
            </div>
            <h3 className="text-2xl font-bold text-gray-900 mb-1">{stat.value}</h3>
            <p className="text-sm text-gray-600">{stat.title}</p>
          </div>
        );
      })}
    </div>
  );
};

export default StockStatistics;